<template>
    <vue-plyr ref="audio-plyr" class="is-block">
        <audio>
            <source :src="audio.url" :type="audio.mimeType" />
        </audio>
    </vue-plyr>
</template>

<script>
export default {
    props: {
        audio: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>

<style></style>
